<template>
  <v-tooltip top max-width="240px">
    <template #activator="{ on }">
      <v-row no-gutters v-on="on">
        <icon-two-line-cell
          :primary-text="locationName"
          :secondary-text="getLocationPath"
          class="location-cell"
        />
      </v-row>
    </template>
    <span>{{ subjectLocation?.name }}</span>
  </v-tooltip>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useLocationQuery } from '@/api/locations'
import IconTwoLineCell from '@/components/forms/cells/IconTwoLineCell.vue'

interface SubjectLocation {
  id: number
  parentId: number
  name: string
}

const props = defineProps<{
  subjectLocation: SubjectLocation
}>()

const { data: parentLocation } = useLocationQuery(props.subjectLocation.parentId)

const hasShortName = computed(() => {
  return props.subjectLocation.name.length <= 3
})

const locationName = computed(() => {
  const locationName = props.subjectLocation?.name ?? ''
  if (hasShortName.value) {
    if (parentLocation.value?.location) {
      return `${parentLocation.value?.location} > ${locationName}`
    }
  }
  return locationName
})

const getLocationPath = computed(() => {
  return parentLocation.value?.location ?? ''
})
</script>

<style scoped>
.location-cell {
  max-width: 240px;
}
</style>
